"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
var day_1 = __importDefault(require("../day"));
function isDate(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$partialDate = _ref.partialDate,
    partialDate = _ref$partialDate === void 0 ? false : _ref$partialDate;
  if (!value) return new classes_1.ValidationResult(true);
  var parms = value.split('/');
  var year = partialDate ? parseInt(parms[1], 10) : parseInt(parms[2], 10);
  var month = partialDate ? parseInt(parms[0], 10) : parseInt(parms[1], 10);
  var day = partialDate ? 1 : parseInt(parms[0], 10);
  var currentDate = new Date();
  var currentYear = currentDate.getUTCFullYear();
  var currentDay = currentDate.getUTCDate();
  var currentMonth = currentDate.getUTCMonth() + 1;
  if (!day_1.default.run(day).isValid) {
    return new classes_1.ValidationResult(false, 'Dia inválido');
  }
  if (month > 12) {
    return new classes_1.ValidationResult(false, 'Mês inválido');
  }
  if (year > currentYear || year < 1900 || year === currentYear && month > currentMonth || year === currentYear && month === currentMonth && day > currentDay) {
    return new classes_1.ValidationResult(false, 'Ano inválido');
  }
  var reference = new Date(year, month - 1, day);
  var refYear = reference.getUTCFullYear();
  var refDay = reference.getUTCDate();
  var refMonth = reference.getUTCMonth() + 1;
  if (refYear !== year || refMonth !== month || refDay !== day) {
    return new classes_1.ValidationResult(false);
  }
  return new classes_1.ValidationResult(true);
}
exports.default = new classes_1.Validator(isDate);